export default __webpack_public_path__ + "static/media/template3.d1feeb67.svg";